"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _reactSelect = require("react-select");

var _Loader = _interopRequireDefault(require("../../general/Loader"));

var _ref = /*#__PURE__*/_react.default.createElement(_Loader.default, {
  size: "tiny"
});

var _default = function _default(props) {
  var className = "".concat(props.className, " hoi-poi-select__loading-indicator");
  return _reactSelect.components.DropdownIndicator && /*#__PURE__*/_react.default.createElement(_reactSelect.components.DropdownIndicator, (0, _extends2.default)({}, props, {
    className: className
  }), _ref);
};

exports.default = _default;